import { render, staticRenderFns } from "./CostsProfileSection.vue?vue&type=template&id=63c2c710"
import script from "./CostsProfileSection.vue?vue&type=script&lang=js"
export * from "./CostsProfileSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports